import { useAppSelector } from 'src/redux/hooks';
import { GlobalState } from 'src/redux/store';

export const languagesSelector = (state: GlobalState) => state.languages;

export const selectLanguages = (state: GlobalState) => languagesSelector(state).data;

export const useLanguages = () => useAppSelector(selectLanguages);
